/**
 * 判断是否为移动设备
 * @returns {boolean}
 */
// export function deviceIsMobile() {
//     const userAgent = navigator.userAgent.toLowerCase();
//     if (userAgent.includes("mobile")) {
//         return true;
//     } else {
//         return window.innerWidth < 1050;
//     }
// }


// 新增的加了一个判断，在服务器端默认返回 false
export function deviceIsMobile() {
    // 检查是否在浏览器环境中
    if (process.client) {
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.includes("mobile")) {
            return true;
        } else {
            return window.innerWidth < 1050;
        }
      }

}